import React from 'react';
import {Link} from 'react-router-dom';
import './GamesPage.css';

export default function GamesPage() {
    return <main className="archive-games">
        <Link className="archive-games-back" to="/resources">← Resources</Link>
        <header className="archive-games-heading">
            <span>CONNAUGHT ARCHIVE</span><h1>Games</h1>
            <p>Fellowship, small mysteries and furniture with very strong opinions.</p>
        </header>
        <div className="archive-games-grid">
            <article className="archive-game-card">
                <img src="/images/lost_jewel.png" alt="The Lost Jewel illustrated cover"/>
                <div className="archive-game-copy"><span className="archive-game-badge">Game in development</span>
                    <h2>The Lost Jewel</h2>
                    <p>A light Irish Masonic adventure about fellowship, humour, history and the little mysteries of lodge life.</p>
                    <Link className="archive-game-play" to="/lost-jewel">Play The Lost Jewel →</Link>
                </div>
            </article>
            <article className="archive-game-card">
                <img src="/images/the-lodge.svg" alt="The Lodge checkerboard and gold column emblem"/>
                <div className="archive-game-copy"><span className="archive-game-badge">Game in development</span>
                    <h2>The Lodge</h2>
                    <p>Prepare the lodge, place the altar and columns, and hunt down supplies. The ceremonial duck is strictly optional.</p>
                    <Link className="archive-game-play" to="/games/the-lodge">Play The Lodge →</Link>
                </div>
            </article>
        </div>
    </main>;
}
